import { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  query,
  where,
  updateDoc,
  doc

} from "firebase/firestore";
import { db } from "../firebase";

import { getFunctions, httpsCallable } from "firebase/functions";

function TransferRequestsSection({ userId, profile, showToast }) {
  const [requests, setRequests] = useState([]);

  useEffect(() => {
    const loadRequests = async () => {
      if (!userId) return;

      const requestsQuery = query(
        collection(db, "transferRequests"),
        where("toUserId", "==", userId),
        where("status", "==", "pending")
      );

      const snapshot = await getDocs(requestsQuery);

      const loadedRequests = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));

      setRequests(loadedRequests);
    };

    loadRequests();
  }, [userId]);

  if (requests.length === 0) {
    return null;
  }

  const declineTransfer = async (requestId) => {
  await updateDoc(doc(db, "transferRequests", requestId), {
    status: "declined",
    declinedAt: new Date().toISOString()
  });

  setRequests(
    requests.filter((request) => request.id !== requestId)
  );

 showToast("Transfer Declined", "The transfer request has been declined.");
};

const acceptTransfer = async (request) => {
  try {
    const functions = getFunctions();

    const acceptTransferRequest = httpsCallable(
      functions,
      "acceptTransferRequest"
    );

    await acceptTransferRequest({
      requestId: request.id
    });

    setRequests(
      requests.filter((item) => item.id !== request.id)
    );

showToast("Transfer Accepted", "The build has been transferred.");
window.location.reload();
  } catch (error) {
    console.log(error);
    alert(error.message);
  }
};

  return (
    <div style={sectionStyle}>
      <h3>Incoming Transfer Requests</h3>

      {requests.map((request) => (
        <div key={request.id} style={requestCardStyle}>
          <strong>{request.carName}</strong>

          <p>From: @{request.fromUsername}</p>

          {request.mileage && (
            <p>Mileage: {request.mileage}</p>
          )}

          {request.note && (
            <p>{request.note}</p>
          )}

          <div style={buttonRowStyle}>
<button
  onClick={() => {
    const confirmed = window.confirm(
      `Accept ownership transfer for ${request.carName}?\n\nThis will add the build to your garage.`
    );

    if (!confirmed) return;

    acceptTransfer(request);
  }}
  style={acceptButtonStyle}
>
  Accept Transfer
</button>

<button
  onClick={() => declineTransfer(request.id)}
  style={declineButtonStyle}
>
  Decline
</button>
</div>

        </div>
      ))}
    </div>
  );
}

const sectionStyle = {
  backgroundColor: "#1f1f1f",
  border: "1px solid #333",
  borderRadius: "14px",
  padding: "16px",
  marginBottom: "20px"
};

const requestCardStyle = {
  backgroundColor: "#111",
  border: "1px solid #333",
  borderRadius: "12px",
  padding: "14px",
  marginTop: "12px"
};

const buttonRowStyle = {
  display: "flex",
  gap: "8px",
  marginTop: "12px",
  flexWrap: "wrap"
};

const acceptButtonStyle = {
  backgroundColor: "#e10600",
  color: "white",
  border: "none",
  padding: "10px 12px",
  borderRadius: "8px",
  fontWeight: "bold",
  cursor: "pointer"
};

const declineButtonStyle = {
  backgroundColor: "#333",
  color: "white",
  border: "1px solid #444",
  padding: "10px 12px",
  borderRadius: "8px",
  fontWeight: "bold",
  cursor: "pointer"
};
export default TransferRequestsSection;